<div class="refreshBox row p-2 m-0">
    <div class="refreshBox col-12">
        {{'general.refresh_banner' | translate}}
    </div>              
</div>
